import { useState } from "react";
import { useErrorDisplay } from "../components/ErrorDisplay"
import ProficiencyClient, { ProficiencyErrors } from "../apiClients/ProficiencyClient"
import { Proficiency } from "../models/dtos"
import { useEffect } from "react";
import { useRef } from "react";
import BusySpinner from "../components/BusySpinner";
import {
    ButtonGroup,
    Paper,
} from "@mui/material";
import ProficiencyDataGrid from "../components/ProficiencyDataGrid";
import ProficiencyUpsertPopup from "../popups/ProficiencyUpsertPopup";
import { Securables, UpsertAction } from "../Enums";
import { useMainDisplayHeight } from "../components/WindowDimensions";
import PanelSegment from "../components/PanelSegment";
import { useSearchBox } from "../components/SearchBox";
import I18NText from "../components/I18NText";
import { I18N } from "../I18N";
import OnlyForRole from "../components/OnlyForRole";
import PageTitle from "../components/PageTitle";
import { DEFAULT_WEIGHT } from "../Constants";


const ProficiencyManagementPage = () => {
    const [ErrorDisplay, setError] = useErrorDisplay();
    const [proficiencies, setProficiencies] = useState<Proficiency[]>([]);
    const [busy, setBusy] = useState<boolean>(false);
    const initialized = useRef<boolean>(false);
    const [SearchBox, searchFilter] = useSearchBox();
    const loadData = async (signal?: AbortSignal) => {
        try {
            setBusy(true);
            let p = await new ProficiencyClient().GetAll(undefined, signal);
            setProficiencies(p);

        } catch (error) {
            setError(error, ProficiencyErrors.GetAll);
        }
        finally {
            setBusy(false);
        }
    };

    useEffect(() => {
        if (initialized.current)
            return;

        initialized.current = true;
        loadData();
    });

    const handleCreate = async (p: Proficiency) => {
        let tp = {
            Name: p.Name,
            Type: p.Type,
            IsNegative: p.IsNegative,
            Weight: DEFAULT_WEIGHT,
            ProficiencyGroupId: null,
            TemplateRevisionId: null,
            AssociationId: null,
        }

        await new ProficiencyClient()
            .Create(tp)
            .then(() => loadData());
    };

    return (
        <>
            <ErrorDisplay />
            <BusySpinner component={Paper} busy={busy}>
                <PanelSegment
                    titleContent={<PageTitle title={<I18NText>Proficiency Bank</I18NText>} />}
                    toolbar={
                        <>
                            <ButtonGroup>
                            <OnlyForRole role={Securables.proficiency_create}><ProficiencyUpsertPopup mode={UpsertAction.Create} showProficiencyGroupSelect={false} onCreate={handleCreate} visibleLabel={I18N.Translate('Add Proficiency')} aria-label={I18N.Translate('Add Proficiency')} /></OnlyForRole>
                            </ButtonGroup>
                            <SearchBox />
                        </>
                    }
                    fillHeight>
                    <ProficiencyDataGrid height={useMainDisplayHeight()} mode={UpsertAction.Update} data={searchFilter(proficiencies)} afterChange={loadData} />
                </PanelSegment>
            </BusySpinner>
        </>
    );
}

export default ProficiencyManagementPage;
